import { useEffect, useState } from 'react';
import type { IBufferingWheelProps } from './BufferingWheel.interface';
import { classNameForElement, StyleElem, styleForElement } from './BufferingWheel.style';

const DELAY_BETWEEN_UPDATES_MS = 800;
const MAX_DOT_COUNT = 2;

function _BufferingText(index: number) {
    let text = 'Buffering';

    for (let count = 0; count < index; count++) {
        text += '.';
    }

    return text;
}

function BufferingWheel(props: IBufferingWheelProps): JSX.Element {
    const style = (elem: StyleElem) => styleForElement(elem, props);
    const className = (elem: StyleElem) => classNameForElement(elem, props);
    const [bufferingCounter, setBufferingCounter] = useState<number>(0);

    useEffect(() => {
        const timeout = setTimeout(() => {
            setBufferingCounter(val => (val > MAX_DOT_COUNT ? 0 : val + 1));
        }, DELAY_BETWEEN_UPDATES_MS);

        return () => {
            clearTimeout(timeout);
        };
    });

    return (
        <div
            aria-live="assertive"
            aria-label="The media player is currently buffering"
            className={className(StyleElem.Container)}
            style={style(StyleElem.Container)}
        >
            <div
                aria-hidden
                className={className(StyleElem.Spinner)}
                style={style(StyleElem.Spinner)}
            />
            {!props.isVideo && (
                <h3 aria-hidden className={className(StyleElem.Text)} style={style(StyleElem.Text)}>
                    {_BufferingText(bufferingCounter)}
                </h3>
            )}
        </div>
    );
}

export default BufferingWheel;
